"use client"

import { cn } from "@/lib/utils"

interface BackgroundPatternProps {
  className?: string
}

export const BackgroundPattern = ({ className }: BackgroundPatternProps) => {
  return (
    <div className={cn("fixed inset-0 -z-10", className)}>
      <div 
        className="absolute inset-0 bg-[bottom_1px_center] dark:bg-[bottom_1px_center] [mask-image:linear-gradient(to_bottom,transparent,50%,white)]"
        style={{
          backgroundImage: `linear-gradient(to right, rgb(243 244 246 / 0.05) 1px, transparent 1px),
            linear-gradient(to bottom, rgb(243 244 246 / 0.05) 1px, transparent 1px)`,
          backgroundSize: '2rem 2rem'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/50 to-background" />
    </div>
  )
} 